import axios, { AxiosRequestConfig } from 'axios';
import { getToken } from '../../utils/auth';
import { getOpenModalFn } from '../modal';
import restaurant from '~/store/restaurant';
import { init } from '@restaurant/api';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: token,
      };
    }

    const restaurantId = restaurant.getRestaurantId();
    if (restaurantId) {
      config.params = {
        ...config.params,
        restaurantId,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  function (error) {
    const { response } = error;
    if (response.status === 401) {
      const openModal = getOpenModalFn();
      if (openModal != null) {
        openModal();
      }
    }
    return Promise.reject(error?.response?.data);
  }
);

const httpClient = {
  get: <T>(url: string, config?: AxiosRequestConfig<any> | undefined) =>
    instance.get<any, T>(url, config),
  post: <T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) => instance.post<any, T>(url, data, config),
  put: <T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) => instance.put<any, T>(url, data, config),
  patch: <T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig<any> | undefined
  ) => instance.patch<any, T>(url, data, config),
  delete: <T>(url: string, config?: AxiosRequestConfig<any> | undefined) =>
    instance.delete<any, T>(url, config),
};

init(httpClient);

export default httpClient;
